module.exports = __webpack_public_path__ + "static/media/chart-3d.7a3193ab.png";